export default __webpack_public_path__ + "static/media/indicaciones.dc708425.svg";